"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SubstanceSpecification_Name = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_SubstanceSpecification_Official_1 = require("./RTTI_SubstanceSpecification_Official");
var RTTI_Reference_1 = require("./RTTI_Reference");
exports.RTTI_SubstanceSpecification_Name = t.recursion('ISubstanceSpecification_Name', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        status: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        preferred: t.boolean,
        _preferred: RTTI_Element_1.RTTI_Element,
        language: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        domain: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        jurisdiction: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        synonym: t.array(exports.RTTI_SubstanceSpecification_Name),
        translation: t.array(exports.RTTI_SubstanceSpecification_Name),
        official: t.array(RTTI_SubstanceSpecification_Official_1.RTTI_SubstanceSpecification_Official),
        source: t.array(RTTI_Reference_1.RTTI_Reference)
    });
});
//# sourceMappingURL=RTTI_SubstanceSpecification_Name.js.map